import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { AppState } from './app/app.state';
import { DinersState } from './diners/diners.state';
import { ErrorState } from './error/error.state';
import { LocationState } from './location/location.state';
import { MenuState } from './menu/menu.state';
import { PaymentState } from './payment/payment.state';
import { PosManagerMenuState } from './pos-manager/pos-menu/pos-menu.state';
import { PosManagerOperatorState } from './pos-manager/pos-operator/pos-operator.state';
import { PosManagerServiceState } from './pos-manager/pos-services-manager/pos-services.state';
import { PosManagerState } from './pos-manager/pos-manager.state';
import { PosScheduleState } from './pos-manager/pos-schedules/pos-schedules.state';
import { TablesState } from 'src/app/store/tables/tables.state';
import { TakeOutDeliveryState } from './takeout-delivery/takeout-delivery.state';
import { TicketItemsState } from './ticket-items/ticket-items.state';
import { TicketsState } from './tickets/tickets.state';
import { TransactionLookupState } from './transaction-lookup/transaction-lookup.state';
import { TransactionsState } from './transactions/transactions.state';
import { SeatsState } from 'src/app/store/seats/seats.state';
import { ngxsConfig } from './ngxs.config';
import { TableReservationsState } from 'src/app/store/tables/reservations/table-reservation.state';
import { HardwareDeviceState } from 'src/app/store/hardware-device/hardware-device.state';
import { TakeoutDeliveryService } from 'src/app/services/takeout-delivery.service';
import { ClosingTheDayState } from 'src/app/store/pos-manager/closing-the-day/closing-the-day.state';
import { PosReportsState } from './pos-manager/pos-reports/pos-reports.state';
import { PrintersState } from './printers/printers.state';

const POS_MANAGER_STATES = [
  PosManagerState,
  PosManagerServiceState,
  PosScheduleState,
  ClosingTheDayState,
  PosReportsState
];

const STORE_STATES = [
  HardwareDeviceState,
  AppState,
  DinersState,
  ErrorState,
  LocationState,
  MenuState,
  PaymentState,
  TablesState,
  SeatsState,
  TicketsState,
  TicketItemsState,
  TransactionsState,
  TransactionLookupState,
  PosManagerMenuState,
  PosManagerOperatorState,
  TakeOutDeliveryState,
  TableReservationsState,
  PrintersState,
  ...POS_MANAGER_STATES
];

@NgModule({
  providers: [TakeoutDeliveryService],
  imports: [NgxsModule.forRoot(STORE_STATES, ngxsConfig)]
})
export class StoreModule {}
